import * as React from 'react'
import './announcementOverlay.css'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

interface IState {
  content: string
  show: boolean
}

export default class AnnouncementOverlay extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      content: this.props.content,
      show: true,
    }
  }
  closeDude(key: string) {
    sessionStorage.setItem(key, 'true')
    this.setState({ show: false })
  }
  findDude(key: string) {
    if (sessionStorage.getItem(key) === 'true') {
      return false
    }
    return true
  }

  render() {
    const content = this.props.content

    return (
      content !== undefined &&
      content.length > 0 &&
      content[0].fields.show &&
      this.findDude(content[0].fields.date) && (
        <div className="overlay-black">
          <div className="overlay-container">
            <h2 className="overlay-heading">{content[0].fields.title}</h2>
            <div
              className="overlay-text-container"
              dangerouslySetInnerHTML={{
                __html: documentToHtmlString(content[0].fields.text).replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br />',
                ),
              }}
            />
            <button
              className="close-overlay-button"
              onClick={() => this.closeDude(content[0].fields.date)}
            >
              Loka
            </button>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/announcementOverlay/announcementOverlay.tsx